<template>
<div>

    <div class="vx-row">
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
            <statistics-card-line icon="UsersIcon"  :statistic="clinics" statisticTitle="Clinics" type='area' style="background:#8eefeb;"></statistics-card-line>
        </div>
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
            <statistics-card-line icon="DollarSignIcon" :statistic="hospitals" statisticTitle="Hospitals" style="background: #f9f56a" color='success' type='area'></statistics-card-line>
        </div>
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
            <statistics-card-line icon="UsersIcon" :statistic="doctors" statisticTitle="Doctors" style="background: #ffb85e" color='danger' type='area'></statistics-card-line>
        </div>
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
            <statistics-card-line icon="ShoppingBagIcon" :statistic="specialization" statisticTitle="Specializations" style="background:rgb(255, 86, 86)" color='warning' type='area'></statistics-card-line>
        </div>
    </div>
</div>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
export default {
    components: {
        StatisticsCardLine
    },

    data() {
        return {
            clinics: "",
            hospitals: "",
            doctors: "",
            specialization: "",
        }
    },
    beforeMount() {
        this.display();
    },

    methods: {
        display() {
            this.$http.post(
                    'getcompanydetails',JSON.stringify(""),
                     {
                        headers: {
                            "Content-Type": "application/json",
                            
                        }
                    }
                )
                .then(response => {
                    this.clinics = response.data.data.totalClinic;
                    this.hospitals = response.data.data.totalHospital;
                    this.doctors = response.data.data.totalDoctor;
                    this.specialization = response.data.data.totalSpecialization;
                });
        },
    }
}
</script>
